import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { addCartItem } from 'store/api'
import { UPDATE_CART_SUMMARY } from 'shared/constants'
import { errorMessage } from 'lib/flash-message'
import { InfoButton } from 'components/buttons'
import { InCartButton } from './in-cart-button'

export const addToCart = async (productId, quantity) => {
  return addCartItem({
    productId,
    quantity,
  })
}

export const AddToBabylistCartButton = ({
  onClick,
  productId,
  quantity,
  size,
  style,
  ...rest
}) => {
  const [addToCartStatus, setAddToCartStatus] = useState('idle')
  const [isInCart, setIsInCart] = useState(false)

  useEffect(() => {
    if (addToCartStatus === 'loading') {
      let canceled = false

      const handleAddToCart = async function addToCartAsync() {
        try {
          await addToCart(productId, quantity)

          if (canceled) return

          setAddToCartStatus('success')
          setIsInCart(true)

          PubSub.publish(UPDATE_CART_SUMMARY, {
            animateBadge: true,
            showCartDropdown: true,
          })
        } catch ({ error }) {
          setAddToCartStatus('idle')
          errorMessage(error.message)
        } finally {
          if (onClick) {
            onClick()
          }
        }
      }

      handleAddToCart()

      return () => {
        canceled = true
      }
    }

    return () => {}
  }, [addToCartStatus, productId, quantity])

  if (isInCart) {
    return <InCartButton />
  }
  return (
    <InfoButton
      onClick={() => setAddToCartStatus('loading')}
      pill
      size={size}
      style={style || { minWidth: 137 }}
      submitting={addToCartStatus === 'loading'}
      {...rest}
    >
      Add to Cart
    </InfoButton>
  )
}

AddToBabylistCartButton.propTypes = {
  onClick: PropTypes.func,
  productId: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  size: PropTypes.oneOf(['small', 'large']),
  style: PropTypes.object,
}

AddToBabylistCartButton.defaultProps = {
  onClick: undefined,
  size: undefined,
  style: undefined,
}
